import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_04c57aca";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_04c57aca" };
/** script content **/
require("./checkbox.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex04c57aca%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fcheckbox%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_04c57aca"],
    ctorType: "component",
    outputPath: "components/index04c57aca/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
